import React from 'react';
import './style.scss';
import clsx from 'clsx';

export enum TeamMemberColors {
  PURPLE = 'purple',
  GREEN = 'green',
  PINK = 'pink',
  BLUE = 'blue',
  YELLOW = 'yellow'
}

export interface TeamMemberProps {
  color: TeamMemberColors;
  src: string;
  name: string;
  role: string;
  className?: string;
}

const TeamMember = ({ color, src, name, role, className }: TeamMemberProps) => (
  <div className={clsx('lfst-member', `lfst-member-${color}`, className)}>
    <div className='member-avatar-wrapper'>
      <img src={src} className='member-avatar' />
    </div>
    <h5 className='member-name'>{name}</h5>
    <h6 className='member-role'>{role}</h6>
  </div>
);

export default TeamMember;
